import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const Reports = () => {
  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Reports
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Analytics and reporting dashboard
      </Typography>

      <Paper elevation={2} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Reports feature coming soon
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This section will include project analytics, financial reports, team utilization, and more.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Reports;
